var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZoomIn(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1430105507"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40413",
    width: 31,
    height: 31,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Compound Path",
    d: "M18.5262 17.642C19.5888 16.3522 20.1144 14.7029 19.9938 13.0361C19.8733 11.3693 19.1159 9.81286 17.8788 8.6894C16.6416 7.56594 15.0195 6.96167 13.3489 7.00189C11.6782 7.0421 10.0871 7.7237 8.90539 8.90539C7.7237 10.0871 7.0421 11.6782 7.00189 13.3489C6.96167 15.0195 7.56594 16.6416 8.6894 17.8788C9.81286 19.1159 11.3693 19.8733 13.0361 19.9938C14.7029 20.1144 16.3522 19.5888 17.642 18.5262L22.9895 23.8737C23.1111 23.9649 23.2615 24.0092 23.4132 23.9984C23.5648 23.9876 23.7075 23.9225 23.815 23.815C23.9225 23.7075 23.9876 23.5648 23.9984 23.4132C24.0092 23.2615 23.9649 23.1111 23.8737 22.9895L18.5262 17.642ZM8.27338 13.5156C8.26922 12.4779 8.57312 11.4623 9.1466 10.5975C9.72008 9.73262 10.5373 9.05744 11.4949 8.65744C12.4524 8.25744 13.5071 8.15062 14.5253 8.3505C15.5436 8.55039 16.4796 9.048 17.2149 9.78029C17.9501 10.5126 18.4515 11.4466 18.6555 12.4641C18.8595 13.4815 18.7569 14.5366 18.3607 15.4957C17.9646 16.4549 17.2927 17.2748 16.4302 17.8518C15.5677 18.4287 14.5533 18.7367 13.5156 18.7367C12.1289 18.7368 10.7987 18.1873 9.81621 17.2088C8.83371 16.2302 8.27895 14.9023 8.27338 13.5156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M15.4519 12.8841H14.1466V11.5789C14.1466 11.4113 14.0801 11.2507 13.9616 11.1323C13.8432 11.0138 13.6825 10.9473 13.515 10.9473C13.3475 10.9473 13.1868 11.0138 13.0684 11.1323C12.95 11.2507 12.8834 11.4113 12.8834 11.5789V12.8841H11.5781C11.4106 12.8841 11.25 12.9507 11.1315 13.0691C11.0131 13.1876 10.9465 13.3482 10.9465 13.5157C10.9465 13.6832 11.0131 13.8439 11.1315 13.9623C11.25 14.0808 11.4106 14.1473 11.5781 14.1473H12.8834V15.4526C12.8834 15.6201 12.95 15.7808 13.0684 15.8992C13.1868 16.0177 13.3475 16.0842 13.515 16.0842C13.6825 16.0842 13.8432 16.0177 13.9616 15.8992C14.0801 15.7808 14.1466 15.6201 14.1466 15.4526V14.1473H15.4519C15.6194 14.1473 15.78 14.0808 15.8985 13.9623C16.0169 13.8439 16.0835 13.6832 16.0835 13.5157C16.0835 13.3482 16.0169 13.1876 15.8985 13.0691C15.78 12.9507 15.6194 12.8841 15.4519 12.8841Z",
    fill: "black"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoomIn.d213ecf6dbbc23be78ccb2f01ec158d6.svg";
export { ForwardRef as ReactComponent };